import axios from 'axios';
import store from '../store/store'
const sanitize = (string) => string.replace(/^\/|\/$/g, '');
const HOST = sanitize(process.env.VUE_APP_EXPRESS_HTTP)

export const upload = (path, buffer) => {
  return axios.post(HOST + '/upload', buffer, {
    headers: {
      'Content-Type': 'application/octet-stream',
      'X-Path': path.toLowerCase(),
      'X-File-Order': store.state.file_order
    }
  })
}

export const version = () => {
  return axios.get(HOST + '/version')
}
